// src/app/splash/splash.page.ts
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-splash',
  standalone: true,
  imports: [IonicModule, TranslateModule],
  templateUrl: './splash-page.page.html',
  styleUrls: ['./splash-page.page.scss'],
})
export class SplashPage {

  constructor(private router: Router) {}

  startAsGuest() {
    // Navigate to the sign-up or guest onboarding process
    this.router.navigate(['/settings']); // Replace with your actual route
  }
}